<!-- ===================== QUIÉNES SOMOS (v3): texto izq. + timeline der. ===================== -->
<section class="about" id="quienes">
  <div class="copy">
    <span class="eyebrow">{{ 'about.eyebrow' | translate }}</span>
    <h2 [innerHTML]="'about.titleHtml' | translate"></h2>
    <p [innerHTML]="'about.p1Html' | translate"></p>
    <p [innerHTML]="'about.p2Html' | translate"></p>
  </div>

  <div class="tl-wrap">
    <div class="tl" #timeline>
      <div class="tl-item" *ngFor="let s of stories; let i = index"
           [attr.data-side]="i % 2 === 0 ? 'left' : 'right'">
        <span class="tl-dot"></span>
        <article class="tl-card">
          <div class="tl-img">
            <img [src]="s.imgExt" [alt]="'about.stories.' + s.key + '.alt' | translate" loading="lazy">
          </div>
          <div class="tl-body">
            <span class="tl-year">{{ s.year }}</span>
            <h3>{{ 'about.stories.' + s.key + '.titleExt' | translate }}</h3>
            <button class="tl-more" type="button" (click)="openModal(i)">
              {{ 'about.saberMas' | translate }}
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m13 6 6 6-6 6"/></svg>
            </button>
          </div>
        </article>
      </div>
    </div>
  </div>
</section>

<!-- ===================== MODAL + CARRUSEL ===================== -->
<div id="modal-container" [class.four]="modalOpen" [class.out]="modalOut">
  <div class="modal-background">
    <div class="close-bar">
      <button type="button" (click)="closeModal()" [attr.aria-label]="'about.close' | translate">
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 24 24">
          <path d="M20.707 3.293a1 1 0 0 1 0 1.414l-16 16a1 1 0 0 1-1.414-1.414l16-16a1 1 0 0 1 1.414 0Z" fill="currentColor"></path>
          <path d="M3.293 3.293a1 1 0 0 1 1.414 0l16 16a1 1 0 0 1-1.414 1.414l-16-16a1 1 0 0 1 0-1.414Z" fill="currentColor"></path>
        </svg>
      </button>
    </div>
    <div class="modal" #modalEl>
      <time [style.background]="current.color">{{ current.year }}</time>
      <h1>{{ 'about.stories.' + current.key + '.titleInt' | translate }}</h1>
      <img [src]="current.imgInt" [alt]="'about.stories.' + current.key + '.alt' | translate">
      <p [innerHTML]="'about.stories.' + current.key + '.desHtml' | translate"></p>
    </div>
    <div class="carousel-nav">
      <button type="button" (click)="prev()" [style.visibility]="hasPrev ? 'visible' : 'hidden'"
              [attr.aria-label]="'about.prev' | translate">
        <span><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="m12.086 4.105.703.704a.38.38 0 0 1 .106.28.514.514 0 0 1-.106.317l-5.45 5.45h11.99c.116 0 .222.046.316.14a.38.38 0 0 1 .105.281v.985a.514.514 0 0 1-.105.316.514.514 0 0 1-.317.106H7.34l5.45 5.449c.07.094.105.199.105.316a.38.38 0 0 1-.106.281l-.703.704a.514.514 0 0 1-.316.105.38.38 0 0 1-.282-.105L4.141 12.05A.334.334 0 0 1 4 11.77c0-.118.047-.211.14-.282l7.348-7.383A.38.38 0 0 1 11.77 4c.117 0 .222.035.316.105Z" fill="currentColor"></path>
          </svg></span>
      </button>
      <button type="button" (click)="next()" [style.visibility]="hasNext ? 'visible' : 'hidden'"
              [attr.aria-label]="'about.next' | translate">
        <span><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="m11.664 4.105-.703.704a.38.38 0 0 0-.106.28c0 .118.036.223.106.317l5.45 5.45H4.42a.437.437 0 0 0-.316.14.38.38 0 0 0-.105.281v.985c0 .117.035.222.105.316.094.07.2.106.317.106H16.41l-5.45 5.449a.514.514 0 0 0-.105.316.38.38 0 0 0 .106.281l.703.704c.094.07.2.105.316.105a.38.38 0 0 0 .282-.105l7.347-7.383a.334.334 0 0 0 .141-.281.334.334 0 0 0-.14-.282l-7.348-7.383A.38.38 0 0 0 11.98 4a.514.514 0 0 0-.316.105Z" fill="currentColor"></path>
          </svg></span>
      </button>
    </div>
  </div>
</div>
